import type { UnifiedImageUploadResponse } from '@mrb91002/shared-types'

import { SECURE_API_BASE } from '../config'

// Unified image upload helper
export async function uploadImage(
  entityType: string,
  file: File,
  entityId?: string,
  idToken?: string,
): Promise<UnifiedImageUploadResponse> {
  console.log('[uploadImage] Called with:', { entityType, filename: file.name, entityId })

  const params = new URLSearchParams({
    entity_type: entityType,
    filename: file.name,
  })

  if (entityId) {
    params.append('entity_id', entityId)
  }

  const url = `${SECURE_API_BASE}/images/upload?${params.toString()}`
  console.log('[uploadImage] Request URL:', url)
  console.log('[uploadImage] Entity type being sent:', entityType)

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/octet-stream',
    },
    body: file,
  })

  if (!response.ok) {
    const error = await response.json()
    console.error('[uploadImage] Upload failed:', error)
    throw new Error(error.message || 'Upload failed')
  }

  const result: UnifiedImageUploadResponse = await response.json() as UnifiedImageUploadResponse
  console.log('[uploadImage] Response:', result)
  return result
}

// Legacy wrappers for backward compatibility
export async function uploadTempPatternImage(patternId: string, file: File, idToken: string) {
  return uploadImage('pattern-temp', file, patternId, idToken)
}

export async function uploadPatternImage(patternId: string, file: File, idToken: string) {
  return uploadImage('pattern-draft', file, patternId, idToken)
}

export async function uploadProfileImage(file: File, idToken: string) {
  return uploadImage('profile', file, undefined, idToken)
}

export async function uploadReviewImage(tempId: string, file: File, idToken: string) {
  return uploadImage('review-temp', file, tempId, idToken)
}

export async function uploadCommentImage(tempId: string, file: File, idToken: string) {
  return uploadImage('comment-temp', file, tempId, idToken)
}

export async function uploadCraftRoomImage(file: File, idToken: string) {
  return uploadImage('craft-room', file, undefined, idToken)
}

export async function uploadTempCraftProjectImage(file: File, idToken: string) {
  return uploadImage('project-temp', file, undefined, idToken)
}

export async function uploadCraftProjectImage(projectId: string, file: File, idToken: string) {
  return uploadImage('project', file, projectId, idToken)
}

export async function uploadMaterialImage(materialId: string, file: File, idToken: string) {
  return uploadImage('material', file, materialId, idToken)
}

export async function uploadTempMaterialImage(file: File, idToken: string) {
  return uploadImage('material-temp', file, undefined, idToken)
}

export async function uploadDraftReviewImage(file: File, idToken: string) {
  return uploadImage('draft-review-temp', file, undefined, idToken)
}
